export default __webpack_public_path__ + "static/media/givestylist.701e02a6.png";